import { Text } from 'components/mvp-typography';
import { useProcessData } from '../utils/hook-useProcessData';
import { QuestionnaireInput } from 'features/patient/assessment/_components/questionnaire-page';

export function ResponseColumn(
  _val: any,
  record: ReturnType<typeof useProcessData>[number]
) {
  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <QuestionnaireInput
          key={`${record.question}-${record.response}`}
          item={{
            id: 0,
            categories: [],
            section: 'test',
            title: 'test',
            value: record.response
          }}
          min={record.configMetadata.min}
          max={record.configMetadata.max}
          disabled
          colorsForward={record.configMetadata.colorsForward}
          iconsForward={record.configMetadata.iconsForward}
          type="slider"
          onChange={() => !!0}
          beforeLabel=""
          afterLabel=""
        />
      </div>

      {/**
       * Render the before and after labels separately because the label text in QuestionnaireInput is rendered inline with the icon
       **/}
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Text
          style={{
            fontSize: 12
          }}
        >
          {record.configMetadata.beforeLabel}
        </Text>
        <Text
          style={{
            fontSize: 12
          }}
        >
          {record.configMetadata.afterLabel}
        </Text>
      </div>
    </div>
  );
}
